"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveMuiTheme = exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    container: {
      display: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'container', 'display'], 'flex'),
      flexShrink: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'container', 'flexShrink'], '0'),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'container', 'width'], '100%'),
      margin: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'container', 'margin'], '0')
    },
    bigInput: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'bigInput', 'fontSize'], '40px'),
      textAlign: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'bigInput', 'textAlign'], 'center')
    },
    areaCodeIcon: {
      fill: (0, _seamlessImmutable.getIn)(theme, ['UTPhoneInput', 'areaCodeIcon', 'fill'], _colors["default"].primary)
    },
    labelIcon: {
      height: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'inputIcon', 'height'], '12px'),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'inputIcon', 'width'], 'auto'),
      fill: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'inputIcon', 'fill'], _colors["default"].gray),
      padding: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'inputIcon', 'padding'], '0px 5px 0px 0px')
    },
    labelContainer: {
      display: 'flex',
      width: '100%',
      alignItems: 'center'
    },
    labelError: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'labelError', 'color'], _colors["default"].error),
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'labelError', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'small'], 12))
    }
  };
};

exports.retrieveStyle = retrieveStyle;

var retrieveMuiTheme = function retrieveMuiTheme(theme) {
  return (0, _styles.createMuiTheme)({
    typography: {
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily'])
    },
    overrides: {
      MuiFormControl: {
        root: {
          minWidth: '70px'
        }
      },
      MuiInput: {
        input: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'], 14)),
          color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'color'])
        },
        underline: {
          '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'underline', 'hover', 'borderBottom'], "1px solid ".concat(_colors["default"].gray))
          },
          '&$disabled:before': {
            borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'underline', 'disabled', 'borderBottom'], "1px solid ".concat(_colors["default"].gray))
          },
          '&:before': {
            borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'underline', 'unfocused', 'borderBottom'], "1px solid ".concat(_colors["default"].gray))
          },
          '&$focused:after': {
            borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'underline', 'focused', 'borderBottom'], "2px solid ".concat(_colors["default"].primary))
          },
          '&:after': {
            borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'underline', 'base', 'borderBottom'], "2px solid ".concat(_colors["default"].primary))
          }
        }
      },
      MuiFormLabel: {
        root: {
          color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'formLabel', 'color']),
          '&$error': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'formLabel', 'errorColor'], _colors["default"].gray)
          },
          '&$focused': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'formLabel', 'focusedColor'], _colors["default"].primary),
            '&$error': {
              color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'formLabel', 'focusedErrorColor'], _colors["default"].error)
            }
          },
          fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'], 14))
        }
      },
      MuiFormHelperText: {
        root: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'helperText', 'fontSize'], 12),
          color: (0, _seamlessImmutable.getIn)(theme, ['UTTextInput', 'helperText', 'color'], _colors["default"].error)
        }
      }
    }
  });
};

exports.retrieveMuiTheme = retrieveMuiTheme;